module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/voicemod-and-msi-logo.e5dbc95a.svg";